
const state = {
  activeTab: 'scheduled',
  openDoctorAssignModal: false,
  selectedAppointment: {}
}

const getters = {
  getActiveTab (state) {
    return state.activeTab
  },
  getDoctorAssignModalHandler (state) {
    return state.openDoctorAssignModal
  },
  getSelectedAppointment (state) {
    return state.selectedAppointment
  }
}

const actions = {
  updateActiveTab ({commit, state, dispatch}, tab) {
    commit('updateActiveTab', tab)
  },
  toggleAssignModal ({commit, state, dispatch}) {
    commit('toggleAssignModal')
  },
  updateSelectedAppointment ({commit, state, dispatch}, appointment) {
    commit('updateSelectedAppointment', appointment)
  }
}

const mutations = {
  updateActiveTab (state, tab) {
    state.activeTab = tab
  },
  toggleAssignModal (state) {
    state.openDoctorAssignModal = !state.openDoctorAssignModal
  },
  updateSelectedAppointment (state, appointment) {
    state.selectedAppointment = appointment
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/appointment_request.js